module.exports = __webpack_public_path__ + "img/woman.cbb5a77a.png";